function normalizeText(value) {
  return String(value || "").replace(/\r\n?/g, "\n").trim();
}

function escapeHtml(value) {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export function serializePreparedProductRecipeNotes(description, steps) {
  const normalizedDescription = normalizeText(description);
  const normalizedSteps = (Array.isArray(steps) ? steps : [])
    .map((step) => normalizeText(typeof step === "string" ? step : step?.text))
    .filter(Boolean);
  const parts = [];

  if (normalizedDescription) {
    parts.push(`<p>${escapeHtml(normalizedDescription).replace(/\n/g, "<br>")}</p>`);
  }
  if (normalizedSteps.length) {
    parts.push(`<ol>${normalizedSteps.map((step) => `<li>${escapeHtml(step)}</li>`).join("")}</ol>`);
  }

  return parts.join("") || null;
}

export function parsePreparedProductRecipeNotes(value) {
  const html = normalizeText(value);
  if (!html) return { description: "", steps: [] };

  const container = document.createElement("div");
  container.innerHTML = html;
  const orderedList = container.querySelector("ol");
  const steps = orderedList
    ? Array.from(orderedList.querySelectorAll(":scope > li"))
      .map((item) => normalizeText(item.textContent))
      .filter(Boolean)
    : [];

  orderedList?.remove();
  const description = normalizeText(container.innerText || container.textContent);
  return { description, steps };
}
